import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Building3DViewIcon, ConstructionHelmetIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferConstructionGalleryQuery} from "../offer/api/get_offer_construction_gallery";
import {OfferViewSectionTracker} from "../offer/detail/components/OfferViewSectionTracking";
import {IOfferDetail} from "../offer/types/IOfferDetail";
import {hasOffer3dView} from "../offer/utils/has_offer_3d_view";
import {IPropertyDetailOffer} from "../property/types/IPropertyDetailOffer";
import {useAppSelector} from "../store/hooks";

const building3dViewImage = require("../offer/images/building3Dview.png");

interface Props {
    onButtonClick: () => void;
    type: "property" | "offer";
}

export const DetailConstructionGallerySection = (props: Props) => {
    const {isMobile} = useUserDevice();
    const isProperty = props.type === "property";
    const propertyDetail = useAppSelector((state) => state.property.property);
    const offerDetail = useAppSelector((state) => state.offerDetail.offer);
    const offer: IPropertyDetailOffer | IOfferDetail = isProperty ? propertyDetail.offer : offerDetail;
    const {data: constructionGallery} = useGetOfferConstructionGalleryQuery(offer.id);

    const has3dView = hasOffer3dView(offer, constructionGallery?.construction_3d_tours);

    const title = has3dView ? "Zdjęcia z budowy i widok 3D" : isMobile ? "Postępy i zdjęcia z budowy" : "Zdjęcia z budowy";
    const icon = has3dView ? (
        <div className={cx(building3dViewImageWrapper, !isProperty && offerIconStyle)}>
            <img src={building3dViewImage} alt="" className={building3dViewImageStyle} loading="lazy" />
            <div className={building3dViewIconOverlay}>
                <Building3DViewIcon fill="white" size="6" />
            </div>
        </div>
    ) : (
        <ConstructionHelmetIcon wrapperColor="var(--colors-primary)" size="7" wrapperSize="8" />
    );

    return (
        <div className={detailConstructionSectionContainer} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_CONSTRUCTION_PHOTOS_SECTION}>
            {icon}
            {!isProperty && <OfferViewSectionTracker itemId={offer.id} sectionName="construction_photos" />}
            <div className={cx(detailConstructionBox, isProperty && propertyStyle)}>
                <div className={textContainer}>
                    <Text variant="headline_2" className={textStyle}>
                        {title}
                    </Text>
                    <Text variant="body_copy_0" className={textStyle}>
                        Zobacz na jakim etapie budowy jest ta inwestycja
                    </Text>
                </div>
                <Button
                    variant="outlined_secondary"
                    onClick={() => {
                        props.onButtonClick();
                    }}
                    className={buttonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.SEE_CONSTRUCTION_STEPS_BUTTON}
                >
                    Zobacz etapy budowy
                </Button>
            </div>
        </div>
    );
};

const building3dViewImageWrapper = css({
    position: "relative",
    flexShrink: 0,
    overflow: "hidden",
    width: "100%",
    height: "96px",

    xs: {
        width: "180px",
        height: "152px"
    }
});

const building3dViewIconOverlay = css({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#00000099"
});

const building3dViewImageStyle = css({
    display: "block",
    position: "relative",
    width: "732px",
    height: "410px",
    objectFit: "cover",
    top: "-232px",
    left: "-278px"
});

const detailConstructionSectionContainer = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    backgroundColor: "#fff",
    borderRadius: 1,
    padding: 2,
    xs: {
        flexDirection: "row",
        alignItems: "flex-start"
    },

    sm: {
        padding: 3
    },
    md: {
        alignItems: "center"
    }
});

const detailConstructionBox = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 3,

    xs: {
        alignItems: "flex-start"
    },
    md: {
        alignItems: "center",
        flexDirection: "row"
    }
});

const propertyStyle = css({
    md: {
        flexDirection: "column",
        alignItems: "flex-start"
    }
});

const offerIconStyle = css({
    md: {
        width: "85px",
        height: "72px"
    }
});

const textContainer = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    xs: {
        gap: 1,
        alignItems: "flex-start"
    }
});

const textStyle = css({
    textAlign: "center",
    xs: {
        textAlign: "left"
    }
});

const buttonStyle = css({
    width: "100%",
    xs: {
        width: "auto"
    }
});
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Building3DViewIcon, ConstructionHelmetIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferConstructionGalleryQuery} from "../offer/api/get_offer_construction_gallery";
import {OfferViewSectionTracker} from "../offer/detail/components/OfferViewSectionTracking";
import {IOfferDetail} from "../offer/types/IOfferDetail";
import {hasOffer3dView} from "../offer/utils/has_offer_3d_view";
import {IPropertyDetailOffer} from "../property/types/IPropertyDetailOffer";
import {useAppSelector} from "../store/hooks";

const building3dViewImage = require("../offer/images/building3Dview.png");

interface Props {
    onButtonClick: () => void;
    type: "property" | "offer";
}

export const DetailConstructionGallerySection = (props: Props) => {
    const {isMobile} = useUserDevice();
    const isProperty = props.type === "property";
    const propertyDetail = useAppSelector((state) => state.property.property);
    const offerDetail = useAppSelector((state) => state.offerDetail.offer);
    const offer: IPropertyDetailOffer | IOfferDetail = isProperty ? propertyDetail.offer : offerDetail;
    const {data: constructionGallery} = useGetOfferConstructionGalleryQuery(offer.id);

    const has3dView = hasOffer3dView(offer, constructionGallery?.construction_3d_tours);

    const title = has3dView ? "Zdjęcia z budowy i widok 3D" : isMobile ? "Postępy i zdjęcia z budowy" : "Zdjęcia z budowy";
    const icon = has3dView ? (
        <div className={cx(building3dViewImageWrapper, !isProperty && offerIconStyle)}>
            <img src={building3dViewImage} alt="" className={building3dViewImageStyle} loading="lazy" />
            <div className={building3dViewIconOverlay}>
                <Building3DViewIcon fill="white" size="6" />
            </div>
        </div>
    ) : (
        <ConstructionHelmetIcon wrapperColor="var(--colors-primary)" size="7" wrapperSize="8" />
    );

    return (
        <div className={detailConstructionSectionContainer} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_CONSTRUCTION_PHOTOS_SECTION}>
            {icon}
            {!isProperty && <OfferViewSectionTracker itemId={offer.id} sectionName="construction_photos" />}
            <div className={cx(detailConstructionBox, isProperty && propertyStyle)}>
                <div className={textContainer}>
                    <Text variant="headline_2" className={textStyle}>
                        {title}
                    </Text>
                    <Text variant="body_copy_0" className={textStyle}>
                        Zobacz na jakim etapie budowy jest ta inwestycja
                    </Text>
                </div>
                <Button
                    variant="outlined_secondary"
                    onClick={() => {
                        props.onButtonClick();
                    }}
                    className={buttonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.SEE_CONSTRUCTION_STEPS_BUTTON}
                >
                    Zobacz etapy budowy
                </Button>
            </div>
        </div>
    );
};

const building3dViewImageWrapper = css({
    position: "relative",
    flexShrink: 0,
    overflow: "hidden",
    width: "100%",
    height: "96px",

    xs: {
        width: "180px",
        height: "152px"
    }
});

const building3dViewIconOverlay = css({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#00000099"
});

const building3dViewImageStyle = css({
    display: "block",
    position: "relative",
    width: "732px",
    height: "410px",
    objectFit: "cover",
    top: "-232px",
    left: "-278px"
});

const detailConstructionSectionContainer = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    backgroundColor: "#fff",
    borderRadius: 1,
    padding: 2,
    xs: {
        flexDirection: "row",
        alignItems: "flex-start"
    },

    sm: {
        padding: 3
    },
    md: {
        alignItems: "center"
    }
});

const detailConstructionBox = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 3,

    xs: {
        alignItems: "flex-start"
    },
    md: {
        alignItems: "center",
        flexDirection: "row"
    }
});

const propertyStyle = css({
    md: {
        flexDirection: "column",
        alignItems: "flex-start"
    }
});

const offerIconStyle = css({
    md: {
        width: "85px",
        height: "72px"
    }
});

const textContainer = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    xs: {
        gap: 1,
        alignItems: "flex-start"
    }
});

const textStyle = css({
    textAlign: "center",
    xs: {
        textAlign: "left"
    }
});

const buttonStyle = css({
    width: "100%",
    xs: {
        width: "auto"
    }
});
